import React from "react";
import { ChakraProvider, Box } from "@chakra-ui/react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import BookAppointment from "./pages/BookAppointment";
import MyAppointments from "./pages/MyAppointments";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Remove the unused minimalSystem
// const minimalSystem = { ... };

// Create the router
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <ProtectedRoute>
          <BookAppointment />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/appointments",
    element: (
      <Layout>
        <ProtectedRoute>
          <MyAppointments />
        </ProtectedRoute>
      </Layout>
    ),
  },
]);

function App() {
  return (
    <ChakraProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ChakraProvider>
  );
}

export default App;
